// extracted by mini-css-extract-plugin
export default {"button":"back-button_button__-prJ3"};